var OnlineChecker = require('onlinechecker');
var SocketStreamHandler = require('socketstreamhandler');
var XHRStreamHandler = require('xhrstreamhandler');
var ts = require('./lib/util.es6').ts;


var BackendController = function (session) {
    this.session = session;
    this.onlineChecker = new OnlineChecker(this.session);
    this.setXHRPost();
    _.bindAll(this, 'processOob', 'oobFail', 'start', '_start', 'beforeUnload', 'idleRestart');
    $(window).on('beforeunload', this.beforeUnload);
};
BackendController.prototype = $.extend({
    streamState: 'disconnected',
    restart: true,
    idleIntervalHandler: null,
    idleInterval: null,
    lastMessageTime: null,
    requestIds: 1,
    maxEid: -1,
    streamId: null,
    
    serverPrefix: '/chat',

    loadingOob: false,
    
    messageQueue: [],
    
    timeOffset: 0,
    oobFailCount: 0,
    
    init: function () {
        if (!this.initialized) {
            this.initialized = true;
            this.initStreamHandler();
            this.onlineChecker.start();
        } else {
            debug.warn('Trying to initialize BackendController again');
        }
    },
    ts: function () {
        return ts() - this.timeOffset;
    },
    tsOffset: function (timestamp) {
        return timestamp + this.timeOffset;
    },
    messageHandlers: {
        // Stream events without an eid, general state
        header: function (message) {
            this.timeOffset = ts() - (message.time*1000);
            this.trigger('connected', message);
            
            this.loadingOob = false;
            this.messageQueue = [];

            this.streamId = message.streamid;
            if (this.streamHandler) {
                this.streamHandler.setQueryParam('stream_id', this.streamId);
            }

            this.startIdleInterval(message.idle_interval);
        },
        oob_include: function (message) {
            this.loadingOob = true;
            this.trigger('oobLoading');
            var httpMethod = 'get';
            var outLogLine = '-> [' + httpMethod.toUpperCase() + ']';
            var inLogLine = '<- [' + httpMethod.toUpperCase() + ']';
            debug.log(outLogLine, message.url);
            var params = {};
            if (this.isXDAPI()) {
                params.session = this.session.getAuthCookie();
            }
            window.API_HOST = message.api_host;
            this._doRequest(httpMethod, window.API_HOST + message.url, params, _.bind(function (response) {
                if (response) {
                    if (response.error || response.success === false) {
                        debug.warn(inLogLine, message.url, response);
                        this.oobFail();
                    } else {
                        debug.log(inLogLine, message.url, response);
                        this.processOob(response);
                    }
                } else {
                    debug.warn(inLogLine, message.url, response);
                    this.oobFail();
                }
            }, this), _.bind(function (response) {
                debug.warn(inLogLine, message.url, response._status, response.message, response);
                this.oobFail();
            }, this));
        },
        oob_skipped: function (message) {
            this.trigger('oobLoading');
            this.trigger('oobLoaded', []);
        },
        idle: function (message) {
            // pass
        }
    },
    
    clearTempUnavailableCountdown: function () {
        if (this.tempUnavailableTimeout) {
            clearTimeout(this.tempUnavailableTimeout);
            this.tempUnavailableTimeout = null;
        }
    },
    tempUnavailableCountdown: function (seconds, callback) {
        this.tempUnavailableTimeout = setTimeout(
            _.bind(this.tempUnavailable, this, seconds, callback),
            1000
        );
    },
    tempUnavailable: function (seconds, callback) {
        if (seconds) {
            this.trigger('tempUnavailableTick', seconds);
            this.tempUnavailableCountdown(seconds - 1, callback);
        } else {
            callback();
        }
    },
    beforeUnload: function (e) {
        // Don't restart the stream when it dies on unload
        this.unloading = true;
        this.restart = false;
    },
    
    // Stream
    setStreamState: function (state) {
        if (this.streamState != state) {
            debug.log('Stream: ' + this.streamState + ' -> ' + state);
            this.streamState = state;
            this.trigger('stream');
            this.trigger('stream:' + this.streamState);
        }
    },
    checkStreamState: function (state) {
        return this.streamState == state;
    },
    _start: function () {
        if (!this.streamHandler) {
            return;
        }
        // Make sure we're still in the starting state
        if (this.checkStreamState('starting')) {
            this.streamHandler.start();
            this.onlineChecker.unbind('onlineChange');
            this.onlineChecker.bind('onlineChange', function () {
                if (this.isOnline()) {
                    this.start(1);
                } else {
                    this.stop(true);
                }
            }, this);
        }
    },
    start: function (delay) {
        if (this.checkStreamState('disconnected')) {
            this.restart = true;
            this.startDelay = delay || 0;
            this.clearStartTimeout();
            this.clearTempUnavailableCountdown();
            this.startTimeout = setTimeout(
                this._start,
                this.startDelay * 1000
            );
            this.setStreamState('starting');
            if (this.startDelay) {
                debug.log('Starting in ' + this.startDelay + 's');
            }
        } else {
            debug.warn('Trying to start a non disconnected stream (' + this.streamState + ')');
        }
    },
    clear: function () {
        this.streamHandler.setQueryParam('stream_id', '');
        this.streamHandler.setQueryParam('since_id', '');
    },
    clearStartTimeout: function () {
        if (this.startTimeout) {
            clearTimeout(this.startTimeout);
            this.startTimeout = null;
        }
    },
    stop: function (offline) {
        if (!this.checkStreamState('disconnected')) {
            if (!offline) {
                this.restart = false;
            }
            if (this.streamHandler) {
                this.streamHandler.stop();
            }
            this.clearIdleInterval();
        } else {
            debug.warn('Trying to stop a disconnected BackendController');
        }
    },
    onNoSocketData: function (failCount) {
        debug.warn('No socket data, falling back to XHR');
        this.setStreamState('disconnected');
        if (this.initFallbackStreamHandler()) {
            this.start();
        }
    },
    onStop: function () {
        this.setStreamState('stopped');
        this.clearTempUnavailableCountdown();
    },
    onConnectionError: function () {
        this.trigger('streamError');
        this.stop();
    },
    offline: function () {
        this.trigger('offline');
        this.onConnectionError();
    },
    unsupported: function () {
        this.trigger('unsupported');
        this.onConnectionError();
    },
    isXDSocket: function () {
        if (window.WS_SOCKET_HOST && window.WS_SOCKET_HOST != this.session.getHost()) {
            return true;
        }
        return false;
    },
    isXDAPI: function () {
        if (window.API_HOST && window.API_HOST != this.session.getOrigin()) {
            return true;
        }
        return false;
    },
    onConnected: function () {
        if (this.streamHandler instanceof SocketStreamHandler && this.isXDSocket()) {
            var cookie = this.session.getAuthCookie();
            this.streamPost("auth", {
                cookie: cookie
            }, _.bind(function (response) {
                if (response.error || response.success === false) {
                    this.processError(response);
                }
            }, this));
        }
        if (this.streamHandler instanceof XHRStreamHandler && !this.xhrFallbackTriggered) {
            this.xhrFallbackTriggered = true;
            this.trigger('xhrFallback');
        }
        this.setStreamState('started');
    },
    onDisconnect: function (failCount) {
        this.setStreamState('disconnected');
        this.trigger('disconnect');
        debug.warn('Backend disconnected', 'oobFailCount: ' + this.oobFailCount, 'failCount: ' + failCount, 'restart?', this.restart, 'online?', this.isOnline());
        if (this.isOnline()) {
            failCount = this.oobFailCount || failCount;
            switch (failCount) {
            case 0:
            case 1:
            case 2:
                if (this.restart) {
                    this.start(failCount);
                }
                break;
            default:
                if (this.restart) {
                    if (failCount < 10) {
                        this.start(10);
                    } else {
                        this.start(30);
                    }
                }
                break;
            }
        } else {
            this.offline();
        }
    },
    onSocketError: function (response) {
        if ("_reqid" in response) {
            this.socketResponse(response);
        }
    },
    onSocketMessage: function (response) {
        if ("_reqid" in response) {
            this.gotMessage();
            this.socketResponse(response);
        } else {
            this.onMessage(response);
        }
    },
    gotMessage: function () {
        this.clearStartTimeout();
        // Set last message time
        this.lastMessageTime = ts();
        this.setStreamState('open');
    },
    onMessage: function (message) {
        this.gotMessage();
        this.processMessage(message, this.loadingOob);
    },
    idleRestart: function () {
        if (this.checkStreamState('starting')) {
            // Already starting, ignore
            return;
        }
        var timeSinceLastMessage = ts() - this.lastMessageTime;
        if (timeSinceLastMessage > this.idleInterval) {
            // Restart the stream if it's gone quiet
            if (this.restart) {
                debug.warn('Idle timeout [' + timeSinceLastMessage + ']: restarting');
                this.streamHandler.stop();
            }
        }
    },
    clearIdleInterval: function () {
        if (this.idleIntervalHandler) {
            clearInterval(this.idleIntervalHandler);
        }
    },
    startIdleInterval: function (interval) {
        if (!interval || interval < 1000) {
            return;
        }
        // Clear any existing interval
        this.clearIdleInterval();
        this.idleInterval = interval;
        this.idleIntervalHandler = setInterval(
            this.idleRestart,
            this.idleInterval
        );
    },
    isOnline: function () {
        return this.onlineChecker.isOnline();
    },
    // Stream handler setup
    setMaxEid: function (eid, bake) {
        if (eid > this.maxEid) {
            this.maxEid = eid;
            if (bake) {
                this.bakeMaxEid();
            }
        }
    },
    bakeMaxEid: function () {
        this.streamHandler.setQueryParam('since_id', this.maxEid);
    },
    getSocketSecure: function () {
        if (window.API_HOST.indexOf('https://') === 0) {
            return true;
        }
        return this.session.isSecure();
    },
    getSocketHost: function () {
        var host;
        if (window.WS_SOCKET_HOST) {
            host = window.WS_SOCKET_HOST;
        } else {
            host = this.session.getHost();
        }
        if (window.WS_SOCKET_PATH) {
            host += window.WS_SOCKET_PATH;
        }
        return host;
    },
    getXHRUrl: function () {
        return this.buildUrl("/stream");
    },
    checkWebSocketSupport: function () {
        if (!this.session.featureCheck('websockets')) {
            return false;
        }
        return !!window.WebSocket;
    },
    bindStreamHandler: function () {
        this.streamHandler.bind('disconnect', this.onDisconnect, this);
        this.streamHandler.bind('connected', this.onConnected, this);
        this.streamHandler.bind('stop', this.onStop, this);
        this.streamHandler.bind('connectionError', this.onConnectionError, this);
    },
    initStreamHandler: function (fallback) {
        if (!fallback && this.checkWebSocketSupport()) {
            this.initSocketStreamHandler();
        } else {
            this.initFallbackStreamHandler();
        }
    },
    initSocketStreamHandler: function () {
        this.streamHandler = new SocketStreamHandler(this.getSocketHost(), this.getSocketSecure());
        this.bind('stream:starting', function () {
            this.streamHandler.setHost(this.getSocketHost());
        }, this);
        this.streamHandler.bind('message', this.onSocketMessage, this);
        this.streamHandler.bind('socketError', this.onSocketError, this);
        this.streamHandler.bind('noData', function () {
            this.unbind('stream:starting');
            this.onNoSocketData();
        }, this);
        
        this.setSocketPost();
        this.bindStreamHandler();
    },
    initXHRStreamHandler: function () {
        this.streamHandler = new XHRStreamHandler(this.getXHRUrl());
        this.streamHandler.bind('message', this.onMessage, this);
        this.streamHandler.bind('noData', this.onDisconnect, this);
        this.setXHRPost();
        this.bindStreamHandler();
    },
    initFallbackStreamHandler: function () {
        if (this.session.featureCheck('xhr') && !$.browser.opera) {
            this.initXHRStreamHandler();
            return true;
        } else {
            this.unsupported();
            return false;
        }
    },
    
    // Messages
    oobFail: function () {
        this.oobFailCount++;
        this.streamHandler.error();
        this.trigger('oobFailed');
        this.loadingOob = false;
    },
    processOobMessages: function (messages) {
        debug.log('OOB length', messages.length);
        _.each(messages, function (message) {
            if (message.cid && message.cid > 0) {
                if (message.bid && message.bid > 0) {
                    debug.log('[OOB ' + message.cid + ' ' + message.bid + ' ' + message.type + ']', message);
                } else {
                    debug.log('[OOB ' + message.cid + ' ' + message.type + ']', message);                }
            } else {
                debug.log('[OOB ' + message.type + ']', message);
            }
            this.processMessage(message);
        }, this);
    },
    processOob: function (messages) {
        this.oobFailCount = 0;
        this.trigger('oobLoaded', messages);
        this.loadingOob = false;
        this.processOobMessages(messages);
        this.handleMessageQueue();
    },
    queueMessage: function (message) {
        this.messageQueue.push(message);
    },
    handleMessageQueue: function () {
        _.each(this.messageQueue, this.triggerMessageEvent, this);
        this.messageQueue = [];
    },
    triggerMessageEvent: function (message) {
        this.trigger('message', message);
        if (this.messageHandlers[message.type]) {
            this.messageHandlers[message.type].call(this, message);
        }
    },
    processError: function (message) {
        var msg = message.error || message.message;
        switch (msg) {
        case 'temp_unavailable':
            debug.warn('Error: temp_unavailable, stopping stream');
            this.stop();
            this.tempUnavailable(30, this.start);
            break;
        case 'auth':
            debug.warn('Error: auth, stopping stream');
            this.trigger('streamAuthError');
            this.stop();
            break;
        case 'auth_timeout':
            debug.warn('Error: auth timeout');
            this.trigger('streamAuthTimeout');
            break;
        case 'set_shard':
            debug.warn('Error: set_shard, stopping stream');
            this.stop();
            this.trigger('setShard', message);
            break;
        }
    },
    processMessage: function (message, queue) {
        if (message.type) {
            if (queue) {
                this.queueMessage(message);
            } else {
                this.triggerMessageEvent(message);
            }
        } else if (message.error || message.success === false) {
            this.processError(message);
        } else {
            debug.warn('Missing type in stream message', message);
        }
    },
    
    // Requests
    buildRawUrl: function (suffix, options) {
        options = options || {};
        var host = options.urlHost || window.API_HOST;
        return host + suffix;
    },
    buildUrl: function (suffix, options) {
        options = options || {};
        var prefix = options.urlPrefix || this.serverPrefix;
        return this.buildRawUrl(prefix + suffix, options);
    },
    _request: function (httpMethod, method, data, callback, ajaxOptions, options) {
        var outLogLine = '-> [';
        if (data._reqid) {
            outLogLine += data._reqid + ' ';
        }
        outLogLine += httpMethod.toUpperCase() + ']';
        debug.log(outLogLine, method, data);
        return this._doRequest(httpMethod, this.buildUrl("/" + method, options), data, _.bind(function (response) {
            var inLogLine = '<- [';
            if (response._reqid) {
                inLogLine += response._reqid + ' ';
            }
            inLogLine += httpMethod.toUpperCase() + ']';
            debug.log(inLogLine, method, response);
            this.triggerResponse(response, $.extend({}, data, {
                _method: method
            }));
            if (callback) {
                callback(response, response._reqid);
            }
        }, this), _.bind(function (response) {
            var inLogLine = '<- [';
            if (response._reqid) {
                inLogLine += response._reqid + ' ';
            }
            inLogLine += httpMethod.toUpperCase() + ']';
            debug.warn(inLogLine, method, response._status, response.message, response);
            if (callback) {
                callback(response);
            }
        }, this), ajaxOptions);
    },
    _doRequest: function (httpMethod, url, data, success, error, ajaxOptions) {
        ajaxOptions = ajaxOptions || {};
        var dataType = ajaxOptions.dataType || 'json';
        ajaxOptions = $.extend(ajaxOptions, {
            url: url,
            data: data,
            type: httpMethod,
            dataType: dataType,
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
        });
        return $.ajax(ajaxOptions).done(_.bind(function (response) {
            if (response) {
                if (success) {
                    success(response);
                }
            } else {
                if (dataType == 'json') {
                    response = {
                        error: true,
                        message: 'empty response',
                        _status: 200
                    };
                }
                if (error) {
                    error(response);
                }
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            var response;
            if (dataType == 'json' && request.responseText !== undefined) {
                try {
                    response = JSON.parse(request.responseText);
                } catch (e) {
                    response = {
                        error: true,
                        message: 'invalid json',
                        json: request.responseText
                    };
                }
            } else {
                response = {
                    error: true,
                    message: request.statusText,
                    text: request.responseText
                };
            }
            response._status = request.status;
            response._statusText = request.statusText;
            if (error) {
                error(response);
            }
        }, this));
    },
    get: function (method, data, callback) {
        return this._request('get', method, data, callback);
    },
    _getRequestId: function () {
        return this.requestIds++;
    },
    setXHRPost: function () {
        this.streamPost = this.post;
    },
    setSocketPost: function () {
        this.streamPost = this.socketPost;
    },
    post: function (method, data, callback, ajaxOptions, options) {
        data = data || {};
        // Add request ID
        if (!data._reqid) {
            data._reqid = this._getRequestId();
        }
        // Add form token
        var sessionAuth = this.session.getAuthCookie();
        if (sessionAuth) {
            data.session = sessionAuth;
        }
        this._request('post', method, data, callback, ajaxOptions, options);
        return data._reqid;
    },
    socketPost: function (method, data, callback) {
        data = data || {};
        // Add request ID
        if (!data._reqid) {
            data._reqid = this._getRequestId();
        }
        // Add method
        data._method = method;
        // Register response handler
        this.bind('socketResponse:' + data._reqid, function (response) {
            if (callback) {
                callback(response);
            }
            this.triggerResponse(response, data);
            this.unbind('socketResponse:' + data._reqid);
        }, this);
        // Send over the socket
        this.streamHandler.send(data);
        return data._reqid;
    },
    triggerResponse: function (response, request) {
        this.trigger('response', response, request);
    },
    socketResponse: function (response) {
        this.trigger('socketResponse:' + response._reqid, response);
    }
}, Backbone.Events);


module.exports = BackendController;



//////////////////
// WEBPACK FOOTER
// ./app/src/backendcontroller.js
// module id = QI8C
// module chunks = 1